import styled, { keyframes } from "styled-components";
import { constants } from "constants";
import { Map } from "components/location/map";

const pulse = keyframes`
  0%, 100% { opacity: .55; }
  50% { opacity: 1; }
`;

const StyledLocation = styled.section`
  width: 100%;
  min-height: 280px;
  display: grid;
  grid-template-columns: minmax(180px, 0.42fr) minmax(320px, 1fr);
  gap: clamp(24px, 5vw, 72px);
  align-items: stretch;
  margin: clamp(70px, 9vw, 138px) 0 90px;
  padding: clamp(28px, 4vw, 52px);
  border: 1px solid rgba(220, 226, 230, 0.11);
  border-radius: 28px;
  background: rgba(20, 33, 47, 0.76);

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    min-height: auto;
    margin: 48px 0 64px;
    padding: 24px;
    border-radius: 20px;
  }
`;

const StyledCopy = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const StyledLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: Roboto-Regular;
  font-size: 11px;
  letter-spacing: 0.16em;
  color: ${constants.colors.orange};
  text-transform: uppercase;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
    animation: ${pulse} 1.8s ease-in-out infinite;
  }
`;

const StyledTitle = styled.h2`
  margin: 30px 0 0;
  font-family: Roboto-Black;
  font-size: clamp(32px, 4vw, 62px);
  line-height: 0.98;
  letter-spacing: -0.05em;
  color: #f0ece5;
  text-align: center;
  text-transform: uppercase;
`;

const StyledMap = styled.div`
  min-height: 230px;
`;

export const Location = () => (
  <StyledLocation aria-labelledby="location-title">
    <StyledCopy>
      <StyledLabel>Currently here</StyledLabel>
      <StyledTitle id="location-title">
        1/E Bogdan Voievod
        <br />
        Chișinău, Moldova
      </StyledTitle>
    </StyledCopy>
    <StyledMap>
      <Map />
    </StyledMap>
  </StyledLocation>
);
